<template>
    <Modal
        v-if="plan && plan.has_coupon"
        v-model:show="modal"
        gradient="info"
        modal-classes="modal-danger modal-dialog-centered"
    >
        <div class="py-3 text-center">
            <i class="mdi mdi-brightness-percent ni-4x"></i>
            <h4 class="heading mt-4">{{ $t('cart.coupon.has_coupon') }}</h4>
        </div>

        <base-input group class="mb-3">
            <input
                type="text"
                v-model="code"
                class="form-control"
                :placeholder="$t('cart.coupon.placeholder')"
                :aria-label="$t('cart.coupon.placeholder')"
                :name="$t('cart.code')"
                :error="errors.first($t('cart.code'))"
                v-validate="'required'"
            />
            <div class="input-group-append">
                <base-button
                    @click="validateCupom"
                    :loading="validating"
                    type="success"
                >
                    {{ validating ? '' : $t('cart.coupon.apply') }}
                </base-button>
            </div>
        </base-input>
        <span>{{
            errors.first($t('cart.code')) ? $t('cart.code_empty') : ''
        }}</span>

        <template #footer>
            <base-button v-if="coupon" type="white" @click="$emit('goCart')">
                {{  $t('cart.go_to_cart') }}
            </base-button>
            <base-button
                type="link"
                class="ml-auto text-white"
                @click="closeModal"
            >
                {{ $t('common.close') }}
            </base-button>
        </template>
    </Modal>
</template>

<script>
import Modal from '../../argon/components/Modal';
import BaseInput from '../../argon/components/Inputs/BaseInput';
import BaseButton from '../../argon/components/BaseButton';

export default {
    emits: ['goCart', 'input', 'update:modelValue'],
    components: {
        Modal,
        BaseInput,
        BaseButton,
    },
    props: {
        plan: {
            type: Object,
        },
        modelValue: {
            type: Boolean,
            description: 'Indica se a modal esta aberta',
        },
        addCart: {
            type: Function,
        },
    },
    data: () => ({
        validating: false,
        code: '',
        coupon: false,
    }),
    computed: {
        modal: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            },
        },
    },
    methods: {
        async validateCupom() {
            try {
                const valid = await this.$validator.validate();
                if (valid) {
                    this.validating = true;
                    this.coupon = true;

                    await this.addCart(this.plan.id, true);

                    const { data } = await this.$store.dispatch('SET_COUPON', {
                        id: this.plan.id,
                        code: this.code,
                        add: true,
                    });

                    this.validating = false;
                    if (data.message && data.message.type === 0) {
                        this.$emit('goCart');
                    }
                }
            } catch (e) {
                this.coupon = false;
                this.validating = false;
            }
        },
        closeModal() {
            this.modal = false;
            this.coupon = false;
            this.addCart(this.plan.id);
        },
    },
};
</script>
